<template>
  <div class="chart-tooltip">
    <div class="tooltip-title" v-if="dataType === 'node'">
      {{ data.eventInfo.eventName }}：{{ getShowLabel(data.eventInfo.showLabel) }}{{ data.eventInfo.name }}
    </div>
    <p v-if="dataType === 'node' && data.eventInfo.groupValue" class="tooltip-group">{{ data.eventInfo.groupValue }}</p>
    <div class="tooltip-title" v-if="dataType === 'edge'">
      <p class="left">
        <span>{{ data.sourceEventInfo.eventName }}</span>
        <span>{{ getShowLabel(data.sourceEventInfo.showLabel) }}{{ data.sourceEventInfo.name }}</span>
      </p>
      到
      <p class="right">
        <span>{{ data.targetEventInfo.eventName }}</span>
        <span>{{ getShowLabel(data.targetEventInfo.showLabel) }}{{ data.targetEventInfo.name }}</span>
      </p>
    </div>
    <p class="num-tips">
      <span>会话数：</span>
      <span>{{ num }}</span>
    </p>
    <p class="num-tips" v-if="dataType === 'edge'">
      <span>转化率：</span>
      <span>{{ rate }}</span>
    </p>
    <p class="num-tips" v-if="dataType === 'node'">
      <span>流失率：</span>
      <span>{{ rate }}</span>
    </p>
    <p class="tooltip-tips" v-if="showClickOpenLabel">点击展开</p>
    <el-button size="small" variant="outline" @click="handleHighLightNode" class="tooltip-btn" v-if="showClickOpenBtn">
      {{ data.isHighLight ? '取消高亮节点' : '高亮节点' }}
    </el-button>
  </div>
</template>

<script>
import Vue from 'vue';

const SankeyChartTooltip = {
  name: 'sankey-chart-tooltip',
  props: {
    data: {
      type: Object,
    },
    dataType: {
      type: String,
    },
    showType: {
      type: String,
      default: () => {
        return 'default';
      },
    },
    highLightNodeBack: {
      type: Function,
    },
    num: {
      type: String,
    },
    rate: {
      type: String,
    },
  },
  computed: {
    showClickOpenLabel() {
      return (
        this.dataType === 'node' &&
        this.showType === 'default' &&
        this.data.value &&
        (!this.data.itemStyle.opacity || this.data.itemStyle.opacity === 1)
      );
    },
    showClickOpenBtn() {
      return this.dataType === 'node' && this.showType === 'operation';
    },
  },
  methods: {
    handleHighLightNode() {
      this.highLightNodeBack(!this.data.isHighLight);
    },
    getShowLabel(showLabel) {
      if (showLabel === 'UN_SELECTED' || showLabel === 'LOSS' || showLabel === 'OTHER_GROUP') {
        return '';
      }
      return `[${showLabel}]`;
    },
  },
};

const getSankeyChartTooltip = propsData => {
  const Constructor = Vue.extend(SankeyChartTooltip);
  const component = new Constructor({
    propsData,
  });
  return component.$mount();
};

export default SankeyChartTooltip;

export { getSankeyChartTooltip };
</script>

<style lang="less">
.sankey-tooltip {
  position: fixed;
  box-sizing: border-box;
  padding: 8px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px #ccc;

  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-width: 10px 6px 10px 6px;
    border-color: #fff transparent transparent transparent;
    border-style: solid;
    position: absolute;
    bottom: -19px;
    left: 0;
    right: 0;
    margin: auto;
  }

  p {
    margin: 0;
    padding: 0;
  }

  .tooltip-title {
    line-height: 20px;
    font-size: 12px;
    color: #333;
    margin-bottom: 8px;
    text-align: center;
    display: flex;
    justify-content: space-between;

    .left,
    .right {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
    }

    .left {
      align-items: flex-start;
      margin-right: 5px;
      span:first-child {
        font-weight: bolder;
      }
    }

    .right {
      align-items: flex-end;
      margin-left: 5px;
      span:first-child {
        font-weight: bolder;
      }
    }
  }

  .tooltip-group {
    line-height: 14px;
    font-size: 10px;
    color: #bbb;
    margin-bottom: 8px;
  }

  .num-tips {
    line-height: 14px;
    font-size: 12px;
    color: #333;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }

  .tooltip-tips {
    line-height: 14px;
    font-size: 10px;
    color: #bbb;
    text-align: center;
  }

  .tooltip-btn {
    display: block;
    margin: 0 auto;
    padding: 5px 15px;
    font-weight: normal;
  }
}
</style>
